import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useSignOut } from "../../actions/SignOutAction";
import AlertModal from "./AlertModal";
import { X } from "lucide-react";
const ConfirmDialogBoxWithUser = ({
  loadingStatusUpdate,
  handleCancel,
  handleConfirm,
  message,
  type,
  userName = "",
  setuserName = () => {},
  confirmMessage,
  hideUsernameInput = false,
}) => {
  const navigate = useNavigate();
  const signOut = useSignOut();

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleConfirmClick = () => {
    if (!hideUsernameInput) {
      if (!userName || !userName.trim()) {
        toast.error("Username is required");
        return;
      }

      const storedUsername = localStorage.getItem("username");

      if (!storedUsername) {
        setAlertMessage("Your session has expired. Please sign in again.");
        setShowAlert(true);
        return;
      }

      if (userName !== storedUsername) {
        toast.error("Username is incorrect");
        return;
      }
    }

    handleConfirm(); // ✅ Proceed with actual confirmation
  };

  const handleAlertConfirm = async () => {
    setShowAlert(false);
    await signOut(); // ✅ Call sign out logic after alert confirmed

    navigate("/signin"); // 🔁 Redirect to signin page after sign out
  };

  useEffect(() => {
    if (!hideUsernameInput) {
      setuserName(""); // Clear username input when dialog opens
    }
  }, []);

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="relative bg-white px-4 py-4 rounded-3xl w-full max-w-xs md:w-[500px] md:max-w-[500px]">
          <button
            onClick={handleCancel}
            className="absolute -top-5 -right-10 p-2 bg-white rounded-full hidden md:block"
          >
            <X size={20} />
          </button>

          <div className="align-middle">
            <h3 className="md:text-xl text-base font-bold mb-4 text-text1 text-center">
              Are you sure?
            </h3>
            <hr />
          </div>

          <div className="pt-6 text-[#4B5563]">
            <p
              className="md:text-base text-xs"
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            />
          </div>

          {!hideUsernameInput && (
            <div className="mb-4 space-y-1 pt-4">
              <label className="font-medium md:text-sm text-xs leading-5 text-text3">
                Enter your username
              </label>
              <input
                type="text"
                placeholder="Enter user name"
                className="primary_input text-text1 w-full p-2 border rounded md:text-sm text-xs"
                value={userName}
                onChange={(e) => setuserName(e.target.value)}
                required
              />
            </div>
          )}

          <div
            className={`flex justify-end gap-2 ${hideUsernameInput ? "mt-8" : "mt-0"}`}
          >
            <button
              onClick={handleCancel}
              className="border-[#D1D5DB] px-4 py-3 rounded-md text-text1 border md:text-sm text-xs"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirmClick}
              className={`px-4 py-2 rounded-md md:text-sm text-xs ${
                type === "activate"
                  ? "bg-primary text-text1"
                  : "bg-[#EF4444] text-white"
              }`}
              disabled={loadingStatusUpdate}
            >
              {loadingStatusUpdate ? "Updating..." : `${confirmMessage}`}
            </button>
          </div>
        </div>
      </div>

      {showAlert && (
        <AlertModal message={alertMessage} onConfirm={handleAlertConfirm} />
      )}
    </>
  );
};

export default ConfirmDialogBoxWithUser;
